import { useEffect } from "react";

const getNavbar = () =>
    document.querySelector<HTMLDivElement>(".bp-navigation-wrapper") ||
    document.querySelector<HTMLDivElement>(".navigation-wrapper");

const lockPageChrome = (navbar: HTMLDivElement) => {
    navbar.style.opacity = "0.1";
    navbar.style.pointerEvents = "none";
    document.body.style.overflow = "hidden";
    window.scrollTo(0, 0);
};

const unlockPageChrome = (navbar: HTMLDivElement) => {
    navbar.style.opacity = "unset";
    navbar.style.pointerEvents = "unset";
    document.body.style.overflow = "unset";
};

/** Dims the navbar and blocks scroll while a list-page edit overlay is open. */
const useEditModeLock = (editMode: boolean) => {
    useEffect(() => {
        const navbar = getNavbar();
        if (!navbar) return;

        if (editMode) lockPageChrome(navbar);
        else unlockPageChrome(navbar);

        return () => unlockPageChrome(navbar);
    }, [editMode]);
};

export default useEditModeLock;
